import React from 'react';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';

export const ResumeSection = ({ title, children, isEmpty = false }) => {
  if (isEmpty) return null;

  return (
    <Box mt={1.5} mb={2}>
      <Typography gutterBottom style={{ marginBottom: 8 }}>
        <b>{title}</b>
      </Typography>
      {children}
    </Box>
  );
};
